import { GridColDef } from '@mui/x-data-grid';

export const DataStates = [
    {
        value: 1,
        label: 'DF / CDMX',
    },
    {
        value: 13,
        label: 'Hidalgo',
    },
    {
        value: 14,
        label: 'Jalisco',
    },
    {
        value: 15,
        label: 'México',
    },
    {
        value: 19,
        label: 'Nuevo León',
    },
];

export const DataAdvertiserType = [
    {
        id: 'Owner',
        type: 'Propietario',
    },
    {
        id: 'Independent agent',
        type: 'Broker pequeño',
    },
    {
        id: 'Medium broker',
        type: 'Broker mediano',
    },
    {
        id: 'Big broker',
        type: 'Broker grande',
    },
    {
        id: 'Possible Buyer',
        type: 'Posible comprador',
    },
];

export const BoolOption = [
    {
        value: '3',
        label: 'Todos',
    },
    {
        value: '1',
        label: 'Si',
    },
    {
        value: '2',
        label: 'No',
    },
];

export const BoolOptionWith3 = [
    {
        value: 3,
        label: 'Todos',
    },
    {
        value: '1',
        label: 'Si',
    },
    {
        value: '0',
        label: 'No',
    },
];

export const NegotiablePriceOption = [
    {
        value: '3',
        label: 'Todos',
    },
    {
        value: '1',
        label: 'Si',
    },
    {
        value: '2',
        label: 'No',
    },
    {
        value: '0',
        label: 'Sin dato',
    },
];

export const ContactableOptions = [
    {
        value: 3,
        label: 'Todos',
    },
    {
        value: 1,
        label: 'Si',
    },
    {
        value: 2,
        label: 'No',
    },
];

export const FromXmlOptions = [
    {
        value: 3,
        label: 'Todos',
    },
    {
        value: "1",
        label: 'Feed',
    },
    {
        value: "0",
        label: 'Directo',
    },
];

export const columnsQualify: GridColDef[] = [
    {
        field: 'users_id',
        headerName: 'Id Usuario',
        width: 90,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'id',
        headerName: 'Id Propiedad',
        width: 150,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'email',
        headerName: 'Email',
        width: 200,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'phone_contact',
        headerName: 'Número de Contacto',
        width: 200,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'broker_type',
        headerName: 'Tipo de anunciante',
        width: 200,
        align: 'center',
        headerAlign: 'center',
        valueGetter: (value) =>
            DataAdvertiserType.find((type) => type.id === value).type,
    },
    {
        field: 'user_frequency',
        headerName: 'Frecuencia de Usuario',
        width: 200,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'sale_price',
        headerName: 'Precio',
        type: 'number',
        width: 130,
        headerAlign: 'center',
    },
    {
        field: 'size_house',
        headerName: 'Área',
        width: 130,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'publish_date',
        headerName: 'Fecha de Publicación',
        width: 180,
        headerAlign: 'center',
    },
    {
        field: 'updated_at',
        headerName: 'Fecha de Actualización',
        width: 180,
        headerAlign: 'center',
    },
    {
        field: 'type',
        headerName: 'Tipo de Propiedad',
        width: 150,
        align: 'center',
        headerAlign: 'center',
        valueGetter: (value) =>
            typesPropertiesOptions.find((property) => property.type === value)
                .label,
    },
    {
        field: 'age',
        headerName: 'Antiguedad',
        type: 'number',
        width: 100,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'full_address',
        headerName: 'Dirección',
        width: 250,
        headerAlign: 'center',
    },
    { field: 'city', headerName: 'Ciudad', width: 150, headerAlign: 'center' },
    {
        field: 'status',
        headerName: 'Estado',
        width: 150,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'export_date',
        headerName: 'Fecha de Exportación',
        width: 180,
        headerAlign: 'center',
    },
    {
        field: 'is_interested',
        headerName: 'Está interesado',
        width: 150,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'interested_date',
        headerName: 'Fecha interesado',
        width: 180,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'offer_from_whatsapp',
        headerName: 'Es contactable',
        width: 180,
        align: 'center',
        headerAlign: 'center',
        valueGetter: (value) =>
            value === 0 ? 'No es contactable' : 'Si es contactable',
    },
    {
        field: 'last_wa_comm_date',
        headerName: 'Fecha último mensaje de WhatsApp',
        width: 300,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'zone_classification',
        headerName: 'Clasificación de zona',
        width: 200,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'median_days',
        headerName: 'Median days',
        width: 150,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'total_capacity',
        headerName: 'Capacidad total',
        width: 150,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'in_range_price',
        headerName: 'Está en el rango de precio',
        width: 200,
        align: 'center',
        headerAlign: 'center',
        valueGetter: (value) => (value === 0 ? 'No' : 'Si'),
    },
    {
        field: 'num_comparable',
        width: 180,
        headerName: 'Número de comparables',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'is_price_negotiable',
        width: 150,
        align: 'center',
        headerName: 'Precio negociable',
        headerAlign: 'center',
        valueGetter: (value) => {
            if (value === 0) {
                return 'No';
            }
            if (value === 1) {
                return 'Si';
            }
            return '-';
        },
    },
    {
        field: 'feed_name',
        width: 180,
        headerName: 'Feed name',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'pipe_drive_deals',
        width: 180,
        headerName: 'Estado pipedrive',
        align: 'center',
        headerAlign: 'center',
    },
];

export const typesPropertiesOptions = [
    {
        id: 5,
        type: 1,
        type_string: 'Residencial',
        subType: 2,
        url: 'casas',
        label: 'Casas',
        gtm: 'selector-property_type | Casas',
    },
    {
        id: 4,
        type: 1,
        type_string: 'Residencial',
        subType: 1,
        url: 'departamentos',
        label: 'Departamentos',
        gtm: 'selector-property_type | Departamentos',
    },
    {
        id: 8,
        type: 1,
        type_string: 'Residencial',
        subType: 13,
        url: 'casas-en-condominio',
        label: 'Casas Condominio',
        gtm: 'selector-property_type | Casas Condominio',
    },
    {
        id: 7,
        type: 1,
        type_string: 'Residencial',
        subType: 6,
        url: 'terrenos-habitacionales',
        label: 'Terrenos Habitacionales',
        gtm: 'selector-property_type | Terrenos Habitacionales',
    },
    {
        id: 6,
        type: 1,
        type_string: 'Residencial',
        subType: 5,
        url: 'ranchos',
        label: 'Ranchos',
        gtm: 'selector-property_type | Ranchos',
    },
    {
        id: 16,
        type: 2,
        type_string: 'Comercial',
        subType: 11,
        url: 'locales',
        label: 'Locales',
        gtm: 'selector-property_type | Locales',
    },
    {
        id: 12,
        type: 2,
        type_string: 'Comercial',
        subType: 3,
        url: 'oficinas',
        label: 'Oficinas',
        gtm: 'selector-property_type | Oficinas',
    },
    {
        id: 15,
        type: 2,
        type_string: 'Comercial',
        subType: 10,
        url: 'edificios',
        label: 'Edificios',
        gtm: 'selector-property_type | Edificios',
    },
    {
        id: 21,
        type: 3,
        type_string: 'Industrial',
        subType: 14,
        url: 'naves-industriales',
        label: 'Naves Industriales',
        gtm: 'selector-property_type | Naves Industriales',
    },
    {
        id: 9,
        type: 1,
        type_string: 'Residencial',
        subType: 9,
        url: 'cuartos',
        label: 'Cuartos',
        gtm: 'selector-property_type | Cuartos',
    },
    {
        id: 14,
        type: 2,
        type_string: 'Comercial',
        subType: 7,
        url: 'terrenos-comerciales',
        label: 'Terrenos Comerciales',
        gtm: 'selector-property_type | Terrenos Comerciales',
    },
    {
        id: 13,
        type: 2,
        type_string: 'Comercial',
        subType: 4,
        url: 'bodegas-comerciales',
        label: 'Bodegas',
        gtm: 'selector-property_type | Bodegas',
    },
    {
        id: 20,
        type: 3,
        type_string: 'Industrial',
        subType: 8,
        url: 'terrenos-industriales',
        label: 'Terrenos Industriales',
        gtm: 'selector-property_type | Terrenos Industriales',
    },
];

export const StatusOptions = [
    {
        value: '0',
        label: 'Status 2',
    },
    {
        value: '1',
        label: 'PCOM',
    },
    {
        value: '2',
        label: 'HABI',
    },
];

export const ZoneClasification = [
    {
        value: 1,
        label: 'Sin experiencia',
    },
    {
        value: 2,
        label: 'Poca experiencia',
    },
    {
        value: 4,
        label: 'Buena experiencia',
    },
    {
        value: 5,
        label: 'Experiencia regular',
    },
];

const listOptions = {
    list_options: BoolOptionWith3,
    option_default: BoolOptionWith3[0].value,
}

export const filtersDropdown = [
    {
        label: 'Existe en pipedrive:',
        name: 'pipe_drive_deals',
        test_id: 'test_id_pipe_drive_deals',
        class_name: 'field-pipe_drive_deals',
        ...listOptions
    },
    {
        label: 'Mensaje de whatsapp enviado:',
        name: 'whatsapp_sent',
        test_id: 'test_id_whatsapp_sent',
        class_name: 'field-whatsapp_sent',
        ...listOptions
    },
    {
        label: 'Propiedad ya fue exportada:',
        name: 'property_exported',
        test_id: 'test_id_property_exported',
        class_name: 'field-property_exported',
        list_options: BoolOptionWith3,
        option_default: BoolOptionWith3[0].value,
    },
    {
        label: 'Usuario ya fue exportado:',
        name: 'user_exported',
        test_id: 'test_id_user_exported',
        class_name: 'field-user_exported',
        list_options: BoolOptionWith3,
        option_default: BoolOptionWith3[0].value,
    },
    {
        label: 'Está interesado:',
        name: 'is_interested',
        test_id: 'test_id_is_interested',
        class_name: 'field-is_interested',
        list_options: BoolOptionWith3,
        option_default: BoolOptionWith3[0].value,
    },
    {
        label: 'Es contactable:',
        name: 'offer_from_whatsapp',
        test_id: 'test_id_is_contactable',
        class_name: 'field-is_contactable',
        list_options: ContactableOptions,
        option_default: ContactableOptions[0].value,
    },
    {
        label: 'Está en rango de precio:',
        name: 'in_range_price',
        test_id: 'test_id_price_range',
        class_name: 'field-price_range',
        list_options: BoolOption,
        option_default: BoolOption[0].value,
    },
    {
        label: 'Comparables:',
        name: 'num_comparable',
        test_id: 'test_id_comparable',
        class_name: 'field-comparable',
        list_options: BoolOption,
        option_default: BoolOption[0].value,
    },
    {
        label: 'Precio negociable:',
        name: 'is_price_negotiable',
        test_id: 'test_id_negotiable_price',
        class_name: 'field-negotiable_price',
        list_options: NegotiablePriceOption,
        option_default: NegotiablePriceOption[0].value,
    },
    {
        label: 'Tipo de inventario:',
        name: 'from_xml',
        test_id: 'test_id_from_xml',
        class_name: 'field-from_xml',
        list_options: FromXmlOptions,
        option_default: FromXmlOptions[0].value,
    },
];
